import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type IPaymentMethod} from './model';

const domain = 'ENTITIES/PAYMENT-METHODS';

export const {
    action: fetchPaymentMethods,
    success: fetchPaymentMethodsSuccess,
    failed: fetchPaymentMethodsFailed,
} = createAction(
    `${domain}/FETCH_ALL`,
    (targetId: string, billPayerId?: string) => ({targetId, billPayerId}),
    (paymentMethods: List<IPaymentMethod>) => ({paymentMethods}),
);
